module.exports = __webpack_public_path__ + "static/media/-1.c7876a20.jpg";